import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useIntl, useSelector } from 'umi';
import moment from 'moment';
import cx from "classnames";
import { Icon, Text, } from "tea-component";
import LineChart from '@/pages/dashboard/components/Chart/components/LineChart';
import CardBox from '@/pages/dashboard/components/CardBox';
import MiniTable from '@/pages/dashboard/components/MiniTable';
import { formatFilterValues, formatNum, formatPercentNum, getIsErrorValue, realTimeRefresh } from '@/pages/dashboard/utils/utils';
import { addChartSymbol, addNewRadarSymbol, contrastLine, DataZoom, xAxisHighLight } from '@/pages/dashboard/components/Chart/_config/plug';
import { exportExcel } from '@/pages/dashboard/pages/realtime/_config/exportExcel'
import { showByApi as showDownloadSettings, DownloadOptions } from '@/pages/dashboard/components/DownloadOptionsModal'
import { getRealtimeEventTypeList, getRevenueData, getPcRevenueData } from '@/pages/dashboard/services/realtime';
import { lineFormatterFunc } from '@/pages/dashboard/components/Chart/_config/utils';
import EventDetailsPop, { useEventDetailsPop } from '../../../eventAnalysis/EventDetailsPop';
import { fillRealtimeEventData } from '../../_config/common';
import { useLinkPath } from '@/pages/dashboard/utils/customHook';
import { getMonetUnit } from '@/pages/dashboard/utils/moneyUnit';

import './index.scss'
import SvgIcon from '@/pages/home/components/SvgIcon';


const getCellValue = (_arr: any[], key: number, ind: string | number) => {
  return _arr[key] && _arr[key][ind]?.count ? _arr[key][ind]?.count : '';
}

const RevenueOperation = (props: any) => {
  const { title, isChangeDate, formValue, gameCode, dispatch, isRefreshEventTypes, refreshStatus, setRefreshStatus, filterLoading,pageShowType } = props
  const { locale, formatMessage } = useIntl();
  const [eventData, setEventData] = useState([])
  const linkPath = useLinkPath("eventAnalysis/eventDetails");
  // 事件详情数据
  const popRef = useRef()
  const { currentEvents, slotConfigFunc } = useEventDetailsPop(eventData, popRef)
  const time = formValue.singleDaily
  const contrastTime = formValue.contrastDaily
  const [data, setData] = useState<any>({})
  const [isLoading, setIsLoading] = useState(true)
  const [isNodata, setIsNodata] = useState(true)
  const [isError, setIsError] = useState(false)
  // const [firstInit, setFirstInit] = useState(false)
  const [revenueTimeId, setRevenueTimeId] = useState<any>(null);
  // const [startTime, setStartTime] = useState<number>(0);
  const startTime = useRef(0)
  const { count, dod, sdlw, line_dot, line_dot_contrast, line_dot_last } = data || {};
  // const data_frame = useSelector(state => state.dashboard?.currentGame?.data_frame || 'mobile');

  const requestServiceObj: any = {
    default:getRevenueData,
    mobile: getRevenueData,
    pc: getPcRevenueData,
    nightingale: getPcRevenueData,
  }

  useEffect(() => {
    if (!filterLoading) {
      startTime.current = (new Date()).getTime()
      getRevenueDataFunc(formValue)
      initRealTimeRefresh(formValue);
      getEventData(formValue)
    }
    // 离开组件时清楚定时器
    return () => {
      clearInterval(revenueTimeId);
    };
  }, [formValue, filterLoading])

  useEffect(() => {
    if (refreshStatus === "loading") {
      // setStartTime((new Date()).getTime());
      startTime.current = (new Date()).getTime()
      getRevenueDataFunc(formValue, true)
    }
  }, [refreshStatus])

  const initRealTimeRefresh = (param) => {
    clearInterval(revenueTimeId);
    const timerId = realTimeRefresh(() => {
      // 无调用接口操作5小时后不实时刷新
      if (((new Date()).getTime() - startTime.current) > 5 * 60 * 60 * 1000) { clearInterval(timerId); return; }
      getRevenueDataFunc(param);
    }, 10);
    gameCode && setRevenueTimeId(timerId);
  }

  const getRevenueDataFunc = async (formValue, isRefresh?: boolean) => {
    !isRefresh && setIsLoading(true)
    const {
      singleDaily,
      contrastDaily,
      ...filters
    } = formValue;

    const params = {
      game_code: gameCode,
      date: singleDaily,
      contrast_day: contrastDaily,
      filters: filters
    }
    const getData = requestServiceObj?.[pageShowType] || requestServiceObj?.default;
    getData(params).then(result => {
      setData(result || {})
      const lineDotLen = result?.line_dot?.length || 0;
      const lineDotContrastLen = result?.line_dot_contrast?.length || 0;
      const lineDotLastLen = result?.line_dot_last?.length || 0;
      const isNodata = lineDotLen === 0 && lineDotContrastLen === 0 && lineDotLastLen === 0
      setIsNodata(isNodata)
      setIsError(false)
      refreshStatus === "loading" && setRefreshStatus("success");
    }).catch((err) => {
      setIsError(true)
      setRefreshStatus("normal");
    }).finally(() => {
      setIsLoading(false)
    })
  }

  // 更新事件详情列表数据
  useEffect(() => {
    if (isRefreshEventTypes) {
      getEventData(formValue)
    }
  }, [isRefreshEventTypes])

  const getEventData = (formValues: any) => {
    const {
      singleDaily,
      contrastDaily,
      ...filters
    } = formValues;

    const params = {
      game_code: gameCode,
      start_time: singleDaily,
      end_time: singleDaily,
      period: 'hours',
      filters: formatFilterValues(filters)
    }
    // 事件管理去掉last_moment选项（接口现在不返回，为兼容逻辑在返回值后添加）
    const addItem = {
      date: singleDaily,
      time: "last_moment",
      events: 0,
      event_list: []
    }
    getRealtimeEventTypeList(params).then(response => {
      const data = response?.list?.length ? [...(response?.list || []), addItem] : []
      setEventData(fillRealtimeEventData(data, 10, 143))
    }).catch(e => {
      console.log('Realtime 事件分析请求错误: ', e)
    }).finally(() => {
      if (isRefreshEventTypes) {
        dispatch({ type: 'dashboard/changeRefreshEvent', payload: { realtime: false } })
      }
    })
  }


  const percentContentList = [{
    title: formatMessage({ id: 'dod' }),
    value: dod
  },
  {
    title: formatMessage({ id: 'sdlw' }),
    value: sdlw
  }];

  const itemPercent = (data, ind) => {
    const { title: _title, value } = data || {};
    const correctVal = !getIsErrorValue(value);
    const val = !(Number(value) < 0);
    return (
      <div className="table-line-text" key={'itemPercent_' + ind}>
        {_title}&nbsp;&nbsp;
        <Text className={cx(
          { "section-data-val": true },
          { 'key-zero': correctVal && val },
          { 'text-green': correctVal && val },
          { 'text-red': correctVal && !val }
        )}>
          {correctVal ? formatPercentNum(parseFloat(value), 1, true) : '-'}
          {
            correctVal && ((Number(value) === 0)
              ? <Icon type={"trend-zero"} />
              : (Number(value) > 0)
                ? <SvgIcon className='overlay-card-body-icon' type="green-up-new" />
                : <SvgIcon className='overlay-card-body-icon' type="red-down-new" />)
          }
        </Text>
      </div>
    )
  }

  const dataByLegend = [line_dot || [], line_dot_last || [], line_dot_contrast || []];
  const maxArr = (JSON.parse(JSON.stringify(dataByLegend)).sort((a, b) => (b.length - a.length)))[0];
  const xAxisData = maxArr.map(i => {
    const _time = i?.time_dot ? moment(i?.time_dot).format('YYYY-MM-DD HH:mm') : '';
    return `${time}${_time.slice(10)}`
  });
  const tableRawData: any[] = []
  const tableData = xAxisData.map((i, ind) => {
    const lineDot = getCellValue(dataByLegend, 0, ind);
    const lineDotLast = getCellValue(dataByLegend, 1, ind);
    const lineDotContrast = getCellValue(dataByLegend, 2, ind);
    tableRawData.push({
      time: i?.slice(11, 16),
      lineDot,
      lineDotLast,
      lineDotContrast
    })
    return {
      time: i?.slice(11, 16),
      lineDot: formatNum(lineDot),
      lineDotLast: formatNum(lineDotLast),
      lineDotContrast: formatNum(lineDotContrast)
    }
  });

  const legendData = [
    `${formatMessage({ id: 'common_today' })} ` + moment(formValue.singleDaily).format('YYYY-MM-DD'),
    `${formatMessage({ id: 'common_yesterday' })} ` + moment(formValue.singleDaily).subtract(1, 'day').format('YYYY-MM-DD'),
    `${!isChangeDate ?
      formatMessage({ id: 'common_sdlw' }) + ' ' + moment(formValue.contrastDaily).format("YYYY-MM-DD") + `  (${formatMessage({ id: 'contrast day' })})` :
      formatMessage({ id: 'contrast day' }) + ' ' + moment(formValue.contrastDaily).format("YYYY-MM-DD")}`
  ]

  const tableHeaders = [
    `${formatMessage({ id: 'common_today' })} ${time}`,
    `${formatMessage({ id: 'common_yesterday' })} ${moment(time).subtract(1, 'day').format('YYYY-MM-DD')}`,
    `${!isChangeDate ?
      formatMessage({ id: 'common_sdlw' }) + ' ' + moment(contrastTime).format("YYYY-MM-DD") + `  (${formatMessage({ id: 'contrast day' })})` :
      formatMessage({ id: 'contrast day' }) + ' ' + moment(contrastTime).format("YYYY-MM-DD")}`
  ];

  const series = legendData.map((i, ind) => {
    const _arr = dataByLegend[ind];
    return {
      name: i,
      type: 'line',
      data: xAxisData.map((_: any, iind: string | number) => {
        return _arr && _arr[iind] ? _arr[iind]?.count : ''
      }),
    }
  })

  const chartData = {
    legendData,
    xAxisData,
    series,
    title,
    tableData,
    tableHeaders,
    tableRawData,
    todayLength: line_dot?.length
  }
  const updateTime = data?.line_dot?.[data?.line_dot?.length - 1]?.time_dot?.slice(11)?.slice(0, 5)
  const subTitleCom = <>
    <div className='table-line-time dbd-realtime-revenue-title'>
      {formatMessage({ id: 'realtime_revenue_realtime_revenue_Statistical' })}:{updateTime ? ` ${updateTime} ` : ' '}
      <span className='table-line-explain'>{formatMessage({ id: 'realtime_revenue_chart_explain' })}</span>
    </div>
    <div className='table-line-flex'>
      <div className={`table-line-num ${isNodata ? 'table-line-num-gray' : ''}`}>{isNodata ? '-' : `${formatNum(count, true, false, getMonetUnit())}`}</div>
      {
        percentContentList.map((i, ind) => itemPercent(i, ind))
      }
    </div>
  </>

  // 下载文件
  const downloadData = async (excelFilterName: string, tableHeaders: any[], tableData: any[], downloadOptions: any = { timeScale: '10' }) => {
    const DEFAULT_TIME_SCALE: number = 10; //接口数据的默认时间间隔
    const DEFAULT_SORT: number = 1;
    const timeScale: number = parseInt(downloadOptions.timeScale);
    const sort: number = downloadOptions.sort;
    const filterName = excelFilterName
    //  表头
    const thead: any = [
      { key: 'time', header: formatMessage({ id: 'realtime_by_country_table_time' }) },
      { key: 'lineDot', header: tableHeaders[0], type: 'number', format: '#,##0.00' },
      { key: 'lineDotLast', header: tableHeaders[1], type: 'number', format: '#,##0.00' },
      { key: 'lineDotContrast', header: tableHeaders[2], type: 'number', format: '#,##0.00' },
    ]
    const table: any[] = tableData.filter((item) => {
      if (timeScale === DEFAULT_TIME_SCALE) return true;
      const min: number = parseInt(item.time?.split(':')?.[1])
      const hour: number = parseInt(item.time?.split(':')?.[0])
      let time: number = hour * 60 + min;
      if (time === 23 * 60 + 59) { // 把最后一刻的时间取整
        time = 24 * 60;
      }
      return time % timeScale === 0;
    })
    if (sort !== DEFAULT_SORT) {
      table.reverse()
    }
    // 导出excel
    exportExcel(filterName, table, thead)
  }
  const lhour: number = tableRawData.length ? parseInt(tableRawData?.[tableRawData.length - 1].time?.split(':')?.[0]) : 0;
  const downloadOptions: DownloadOptions = {
    formatMessage,
    options: {
      timeScale: {
        show: {
          '5': false,
          '10': true,
          '60': true,
        },
        disabled: {
          '5': false,
          '10': false,
          '60': lhour < 1,
        },
        default: '10'
      },
      // sort: {default:0}
    }
  }
  // 表格配置
  const getTableOpt = (tableHeaders) => {
    return [
      {
        key: "time",
        align: "left",
        fixed: "left",
        width: 100,
        header: formatMessage({ id: 'realtime_by_country_table_time' }),
        render: cvm => (<span>{cvm?.time}</span>),
      },
      {
        key: "line_dot",
        align: "right",
        width: 100,
        header: tableHeaders[0]/* "Today" */, // 变化
        render: cvm => (<span>{formatNum(cvm?.lineDot)}</span>)
      },
      {
        key: "line_dot_last",
        align: "right",
        width: 100,
        header: tableHeaders[1]/* "Last day" */, // 变化
        render: cvm => (<span>{formatNum(cvm?.lineDotLast)}</span>)
      },
      {
        key: "line_dot_contrast",
        align: "right",
        width: 100,
        header: tableHeaders[2]/* "Last week(Contrast day)" */, // 变化
        render: cvm => (<span>{formatNum(cvm?.lineDotContrast)}</span>)
      },
    ];
  }
  const { todayLength } = chartData

  const renderList = useMemo(() => {
    return [
      {
        type: 'lineChart',
        svgType: 'discount-chart',
        content: formatMessage({ id: "common_line_chart" }),
        component: (
          <>
            <LineChart
              height={350}
              hasDataZoom={true}
              legendData={xAxisData.length > 0 ? legendData : []}
              xAxisData={xAxisData || []}
              series={xAxisData.length > 0 ? series : []}
              formatterFunc={(e) => (lineFormatterFunc(e, formatMessage({ id: "realtime_revenue" }, { unit: getMonetUnit() }), false, true))}
              setOtherConfigFunc={(opt) => {
                opt.grid.x2 = 15
                opt = addChartSymbol(opt, {
                  showList: ['new', 'max'],
                  formatter: (params) => {
                    return formatNum(params?.value)
                  },
                  todayLength
                })
                // opt = addNewRadarSymbol(opt, {
                //   formatter: (params: any) => {
                //     return formatNum(params?.value)
                //   },
                // })
                opt = DataZoom(opt)
                opt = contrastLine(opt, {
                  formatter: (value) => {
                    return value ? value?.slice(11, 16) : ''
                  },
                })
                opt = xAxisHighLight(opt, {
                  formatter: (params) => {
                    return params.value ? params.value?.slice(11, 16) : ''
                  },
                  isRealtime: true
                })
                return opt
              }}
              chartEventConfig={slotConfigFunc}
            />

          </>

        ),
      },
      {
        type: 'sheet',
        svgType: 'sheet',
        content: formatMessage({ id: "common_table" }),
        component: (<MiniTable
          height={350}
          loading={false}
          tableOption={getTableOpt(tableHeaders)}
          tableConfig={{ isSortable: true, columns: ['time'], defaultValue: [{ by: 'time', order: 'desc' }] }}
          tableList={tableData}
        />),
      }
    ]
  }, [data, locale, eventData])

  return (
    // <div className='dbd-register-tabledbd-realtime-revenue-box'>
    <>
      <CardBox
        className='register-tabledbd-realtime-revenue-paceholder dbd-realtime-revenue-box'
        titleCom={title}
        // 添加key，不然更新可能无法实时，例如事件的点
        key={JSON.stringify(formValue) + JSON.stringify(eventData) + locale}
        subTitleCom={subTitleCom}
        renderList={renderList}
        downloadClick={async () => {
          try {
            const val = await showDownloadSettings(downloadOptions);
            downloadData(title, tableHeaders, tableRawData, val);
          } catch (error) {
            console.log(error)
          }

        }}
        isLoading={isLoading}
        isError={isError}
        isNodata={isNodata}
        bordered={false}
      />
      <EventDetailsPop
        currentEvents={currentEvents}
        pathname={linkPath}
        timeType={'Hour'}
        popRef={popRef}
        style={{ top: '81%' }}
      />
    </>
    // </div>
  );
};
export default connect((state: any) => {
  return {
    isRefreshEventTypes: state.dashboard?.refreshEvent.realtime,
  }
})(RevenueOperation)
